export const environment = {
  authorization: {
    issuer: 'https://sso.shareview.dev',
    clientId: 'shareview-clinician',
    scope: 'openid profile offline_access roles shareview',
  },
  apiBaseUrl: 'https://api.shareviewtesting.com',
  appId: 4,
  environment: 'stage',
  signalR: {
    hubPath: '/ShareViewHub',
  },
  teleEngine: {
    environment: 'development'
  },
};
